import { animate, animateChild, group, query, style, transition } from '@angular/animations';
export const fadeScaleIf = [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.9)' }),
    animate('0.15s ease-out', style({ opacity: 1, transform: 'scale(1)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'scale(1)' }),
    animate('0.15s ease-out', style({ opacity: 0, transform: 'scale(0.9)' })),
  ]),
];

export const fadeScaleIfAmount = (amount: number) => [
  transition(':enter', [
    group([
      style({ opacity: 0, transform: `scale(${amount})` }),
      animate('0.15s ease-out', style({ opacity: 1, transform: 'scale(1)' })),
      query('*', animateChild()),
    ]),
  ]),
  transition(':leave', [
    group([
      style({ opacity: 1, transform: 'scale(1)' }),
      animate('0.15s ease-out', style({ opacity: 0, transform: `scale(${amount})` })),
      query('*', animateChild()),
    ]),
  ]),
];
